<template>
  <div class="ui segment">
    <div class="ui top attached label">
      <i class="info circle icon"></i> Identification:
    </div>
    <div>
      <b>Name</b>
      : {{getI18n(producer.name,"en")}}
    </div>
    <br>
    <div>
      <b>Title</b>
      : {{getI18n(producer.title,"en")}}
    </div>
    <br>
    <div>
      <b>Description</b>
      : {{getI18n(producer.description,"en")}}
    </div>
    <br>
    <div v-if="producer.email != null">
      <b>Email :</b>
      {{producer.email}}
    </div>
  </div>
</template>

<script>
export default {
  props: ["producer"],
  methods: {
    /**
     * Getter to get the value according the the internationalisation
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    }
  }
};
</script>

<style>
</style>
